module.exports = __webpack_public_path__ + "static/media/settings.e0ae8173.svg";